import { COLORS } from '../constants/colors';
const gradientKeys = ['rainbow', 'pink', 'green', 'blue', 'purple'];
export const valueIsGradientColor = (value) => gradientKeys.includes(value);
export const gradientColorVariant = {
    rainbow: COLORS.GRADIENT['RAINBOW-HORIZONTAL'],
    pink: COLORS.GRADIENT['PINK'],
    green: COLORS.GRADIENT['GREEN'],
    blue: COLORS.GRADIENT['BLUE'],
    purple: COLORS.GRADIENT['PURPLE'],
};
